import { useMemo } from 'react';
import { PLATFORMS, PLATFORM_NAMES, detectPlatform } from 'constants/platform';

export default function usePlatform() {
  return useMemo(() => {
    const resolvedPlatform = detectPlatform();
    return {
      platform: resolvedPlatform,
      platformName: PLATFORM_NAMES[resolvedPlatform],
      isVirtualPro: resolvedPlatform === PLATFORMS.VIRTUAL_PRO,
      isHubilo: resolvedPlatform === PLATFORMS.HUBILO,
      isWebinarPlus: resolvedPlatform === PLATFORMS.WEBINAR_PLUS,
    };
  }, []);
}
